import styled from '@emotion/styled';
import {
  color,
  space,
  layout,
  flexbox,
  grid,
  shadow,
  border,
  typography,
  background,
} from 'styled-system';

export const Box = styled('div')(
  color,
  space,
  layout,
  flexbox,
  grid,
  shadow,
  border,
  typography,
  background
);
